import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { Configuration } from '../configuration';
import { AvenantDocument } from '../models/avenantDocument.model';
import { AvenantOverviewResponse } from '../models/avenantOverviewResponse.model';

@Injectable({
  providedIn: 'root'
})
export class EndorsementService {
  public configuration = new Configuration();
  baseUrl: string;
  apiEndpoint: string = 'endorsement';

  constructor(private http: HttpClient, configuration: Configuration) {
    this.baseUrl = configuration.apiBasePath ?? '';
  }

  public getEndorsementDocuments(id: Guid) {
    return this.http.get<AvenantDocument[]>(`${this.baseUrl}${this.apiEndpoint}/${id}/documents`);
  }

  public getEndorsementOverview(
    agreementId: Guid,
    context: Guid,
    email: string
  ): Observable<AvenantOverviewResponse> {
    let filter = new HttpParams();

    if (context) {
      filter = filter.append('contextId', context.toString());
    }

    if (email) {
      filter = filter.append('email', email);
    }
    return this.http.get<AvenantOverviewResponse>(
      `${this.baseUrl}${this.apiEndpoint}/${agreementId}/overview`,
      {
        params: filter
      }
    );
  }
}
